import { useStorage } from '@vueuse/core'

export type GameVersion = 'ms' | 'mscw'

// The world the visitor last picked in CwWorldToggle. A reactive ref persisted to localStorage
// under the same name, so any writer updates every reader (MenuLink today) immediately, with
// no navigation required. vueuse guards the storage access, so a browser that blocks
// localStorage just falls back to the default.
export const selectedGameVersion = useStorage<GameVersion>('selectedGameVersion', 'ms')
